var ip = require('ip');

var Variables = exports;

Variables.types = function(){
	return [
			{
				id:'text',
				name:'Text line',
				field_type:'text',
				validate:(str)=>{
					return str.trim().length > 0;
				},
			},
			{
				id:'int',
				name:'Integer',
				field_type:'number',
				validate:(str)=>{
					str = new String(str);
					return /^-{0,1}\d+$/.test(str);
				},
			},
			{
				id:'textarea',
				name:'Multi-line text',
				field_type:'textarea',
				validate:(str)=>{
					return str.trim().length > 0;
				},
			},
			{
				id:'ip',
				name:'IP Address',
				field_type:'text',
				placeholder:'eg. 192.168.1.134',
				validate:(str)=>{
					return str.length > 0 && (ip.isV4Format(str) || ip.isV6Format(str));
				},
			},
			{
				id:'ip+subnet',
				name:'IP Address with subnet',
				field_type:'text',
				placeholder:'eg. 192.168.1.134/26',
				validate:(str)=>{
					return !! this.calculateIPSubnet(str);
				}
			},
		];
}

// Add any subvariables required to the variables array
Variables.expand = function(variables){
	var newvariables = [];
	for (var i = 0; i < variables.length; i++) {
		var variable = variables[i];

		// Clear any existing
		delete variable.subvariables;

		switch(variable.type){
			case 'ip+subnet':
				variable = this.expandIPVariable(variable);
				break;
		}

		newvariables.push(variable);
	}
	return newvariables;
}


Variables.renderField = function(variable){
	var variabletype = this.types().find((p)=>p.id==variable.type);
	if(!variabletype) return;
	return {
			name : variable.label,
			label : variable.label,
			autocomplete : 'configaro-'+variable.label.replace('_','-'),
			label_help : variable.type != 'text' ? variabletype.name : null ,
			placeholder : variabletype.placeholder ,
			// label_help : variable.prompt,
			type : variabletype.field_type,
			validateValue : variabletype.validate,
		};
}


Variables.valuesAreValid = function(values,variables){
	var self = this;
	return variables.reduce((a,c)=>(!a)?a:self.valueIsValid(values[c.label],c),true);
}


Variables.valueIsValid = function(value,variable){
	var variabletype = this.types().find((p)=>p.id==variable.type);
	return variabletype.validate(value||'');
}


Variables.calculateIPSubnet = function(str){
	var xstr = str.split('/');
	if( ip.isV4Format(xstr[0]) && xstr.length == 2){
		var subnet = null;
		if(ip.isV4Format(xstr[1])){
			subnet = ip.subnet(...xstr);
		} else if( xstr[1].match(/^-{0,1}\d+$/) ){
			subnet = ip.cidrSubnet(str);
		}
		if(subnet && subnet.length){
			return subnet;
		}
	}

	return false
}

Variables.expandIPVariable = function(variable) {
	var subnetSubvariable = (label, key) => {
		return {
			parent: variable.label,
			label: [variable.label,label].join('.'),
			lid: [variable.lid,label].join('.'),
			calculate: (parent_val) => {
				if(!parent_val)
					return '';

				if (label === 'ip')
					return parent_val.split('/').shift();

				var subnet = this.calculateIPSubnet(parent_val);
				if(!subnet)
					throw 'Invalid subnet';

				if (label === 'wildcard_mask')
					return subnet['subnetMask'].split('.').map(n => 255 - n).join('.');

				return subnet[key];
			}
		};
	};

	variable.subvariables = [
		subnetSubvariable('ip'),
		subnetSubvariable('subnet_mask','subnetMask'),
		subnetSubvariable('subnet_mask_length','subnetMaskLength'),
		subnetSubvariable('network_address','networkAddress'),
		subnetSubvariable('first_address','firstAddress'),
		subnetSubvariable('last_address','lastAddress'),
		subnetSubvariable('broadcast_address','broadcastAddress'),
		subnetSubvariable('n_hosts','numHosts'),
		subnetSubvariable('wildcard_mask'),
	];
	return variable;
}


Variables.findVariable = function(label,variables){
	return this.findVariableWithSplitLabel(label.split('.'),variables);
}


Variables.findVariableWithSplitLabel = function(label_array,variables){
	var search = label_array.shift();
	var variable = variables.find(p=>p.label==(p.parent?p.parent+'.':'')+search);

	if(label_array.length == 0){
		return variable;
	} else {
		return this.findVariableWithSplitLabel(label_array,variable.subvariables||[]);
	}
}


Variables.mergeValuesIntoBody = function(variables,values,body){
	var b = body;
	var expanded_vars = Variables.expand(variables);
	var insertVariableValue = (subject,label,value)=> subject.replace(new RegExp('{{'+label+'}}','g'), typeof value === "undefined" ? '{{'+label+'}}' : value);
	var valSet = (v)=> (typeof v !== "undefined" ) && v !== null;

	for (var i = 0; i < expanded_vars.length; i++) {
		var p = expanded_vars[i];
		var v = values[p.label];
		if(valSet(v)) b = insertVariableValue(b,p.label,v) ;
		if(p.subvariables){
			for (var j = 0; j < p.subvariables.length; j++) {
				var sp = p.subvariables[j];
				if(sp.calculate){
					var sv = sp.calculate(v);
					if(valSet(sv)) b = insertVariableValue(b,sp.label,sv) ;
				}
			}
		}
	}
	return b;
}